module.exports = __webpack_public_path__ + "img/gzh.8ad97aec.jpg";